
import { Options, Prop, Vue } from 'vue-property-decorator'
import { RouteLocationRaw } from 'vue-router'

import NavLink from '../components/NavLink.vue'

@Options({
  name: 'PageLayout',
  components: {
    NavLink
  }
})
export default class PageLayout extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  readonly title!: string

  @Prop({
    type: String,
    default: ''
  })
  readonly description!: string

  @Prop({
    type: Array,
    default: () => []
  })
  readonly breadcrumb!: Array<{ url: RouteLocationRaw, label: string }>

  url = ''

  hasSlot (key: string) {
    const slot = this.$slots[key]
    const vnodes = slot && slot()

    if (vnodes) {
      for (const i in vnodes) {
        if (typeof vnodes[i].type !== 'symbol' || vnodes[i].children?.length) {
          return true
        }
      }
    }
    return false
  }

  mounted () {
    this.url = window.location.href
  }
}
